import * as React from 'react';
import GrafikJurnal from './GrafikJurnal';

export default function GrafikJurnalAuth() {
    
    return (
            <GrafikJurnal auth={true}/>
    );
}
